/**
 * User Filters Component
 * Inline filter bar: filters stay visible and apply live (no popover).
 */

import React from 'react';
import { InlineFilterBar, InlineMultiSelect } from '../../../components/common';
import { useFilterState } from '../../../hooks/useFilterState';
import { UserStatus, USER_STATUS_LABELS } from '../../../types/user';

// Types
interface UserFiltersData {
  searchTerm: string;
  situacao: string[];
}

interface UserFiltersProps {
  onFilter: (filters: UserFiltersData) => void;
  loading?: boolean;
  total?: number;
}

// Options
const STATUS_OPTIONS = Object.values(UserStatus).map((s) => ({
  value: s,
  label: USER_STATUS_LABELS[s],
}));

const defaultValues: UserFiltersData = {
  searchTerm: '',
  situacao: [],
};

const UserFilters: React.FC<UserFiltersProps> = ({ onFilter, loading = false, total }) => {
  const { filters, setFilter, clearAll, activeChips } = useFilterState(defaultValues, {
    onFilter,
    applyOnMount: true,
    live: true,
    labels: {
      situacao: 'Status',
    },
    formatValue: {
      situacao: (v: string[]) =>
        v.map((s) => USER_STATUS_LABELS[s as UserStatus] ?? s).join(', '),
    },
  });

  return (
    <InlineFilterBar
      searchPlaceholder="Buscar por nome, e-mail ou CPF"
      searchValue={filters.searchTerm}
      onSearchChange={(v) => setFilter('searchTerm', v)}
      resultCount={total}
      resultNoun="usuários"
      chips={activeChips}
      onClearAll={clearAll}
      loading={loading}
    >
      <InlineMultiSelect
        label="Status"
        value={filters.situacao}
        options={STATUS_OPTIONS}
        onChange={(v) => setFilter('situacao', v)}
        minWidth={150}
      />
    </InlineFilterBar>
  );
};

export default UserFilters;
